<div class="card card-body">
  <div class="card-head">
    <div class="col-3 pl-0">
      <select
        name=""
        id=""
        class="form-control"
        (change)="filterProspects($event.target.value)"
      >
        <option
          *ngFor="let item of prospectTypes; let i = index"
          [value]="item.value"
        >
          {{ item.viewValue }}
        </option>
      </select>
    </div>
  </div>

  <div class="table-wrap">
    <div class="table-body">
      <ul matSort (matSortChange)="sortData($event)">
        <li class="table-heading table-row">
          <ul class="column-row">
            <li class="tbl-block col-2" mat-sort-header="id">ID</li>
            <li class="tbl-block col-4">Name</li>
            <li class="tbl-block col-4">Email</li>
            <li class="tbl-block col-2">Postcode</li>
          </ul>
        </li>

        <li class="table-row" *ngFor="let item of prospectList; let i = index">
          <ul class="column-row cursorP">
            <li class="tbl-block col-2">
              P{{
                (item.type == 1 ? "R" : "D") +
                  item.indexId.toString().padStart(4, "0")
              }}
            </li>

            <li class="tbl-block col-4">
              {{ item.name }}
            </li>
            <li class="tbl-block col-4">
              {{ item.email }}
            </li>

            <li class="tbl-block col-2">
              {{ item.postcode }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
